import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'smrts-dialog-error',
  templateUrl: './dialog-error.component.html',
  styleUrls: ['./dialog-error.component.scss'],
  standalone: false
})
export class DialogErrorComponent {

  title: string;
  message: string;
  errorCode: number;


  constructor(
    private dialogRef: MatDialogRef<DialogErrorComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) private data: { errorCode: number }
  ) {
    this.errorCode = data.errorCode;
    this.setMessage(this.errorCode);

  }


  setMessage(errorCode: any): void {
    switch (errorCode) {
      case 401:
        this.title = 'Sessão Expirada';
        this.message = 'Sessão expirada ou acesso não permitido.<br>Por favor, tente se logar novamente.';
        break;
      case 500:
      default:
        this.title = 'Erro';
        this.message = 'Não foi possível conectar ao servidor.<br>Por favor, entre em contato com a administração.';
        break;
    }
  }

  close(): void {
    if (this.errorCode === 401) {
      this.router.navigateByUrl('/login');
    }
    this.dialogRef.close();
  }


}
